<template>
  <div class="notice-code min-height padding">
    <h3>{{title}}</h3>

    <div class="code-box flex align-center justify-around">
      <div>
        <p>报名二维码</p>
        <img :src="sginUp" alt="">
        <el-link :underline="false" class="down-btn" :href="sginUp" target="_blank"><el-button type="primary">下载报名二维码</el-button></el-link>
      </div>
      <div>
        <p>签到二维码</p>
        <img :src="sginIn" alt="">
        <el-link :underline="false" class="down-btn" :href="sginIn" target="_blank"><el-button type="primary">下载签到二维码</el-button></el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { noticeQrcodeShow } from '@/api/admin'
export default {
  name: "noticeCode",
  data () {
    return {
      title:'',
      sginUp:'',
      sginIn:'',
    }
  },
  created () {
    this.title = this.$route.query.name
    this.$emit("setIndex", '/admin/noticeDetail', "通知公告  /  二维码", true, 'icon-gonggao');
    this.getCode()
  },
  components: {},
  methods: {
    async getCode(){
      let _data = await noticeQrcodeShow(this.$route.params.id)
      this.sginUp = _data.data.qrcode_signup
      this.sginIn = _data.data.qrcode_signin
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.notice-code{
  h3{
    font-size: 20px;
  }
  .code-box{

    margin: 30px auto;
    p{
      text-align: center;
      font-size: 18px;
      margin-bottom: 20px;
    }
    img{
      width: 300px;
    }
    .down-btn{
      display: flex;
      margin: 20px auto;
    }
  }
}
</style>